export default __webpack_public_path__ + "static/media/ic_madagascar.ceebb54f.svg";